import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card-margin-bottom"
}

import ComCascaderSearch from "@/components/common/ComCascaderSearch.vue";
import ComLoading from "@/components/common/ComLoading.vue"
import ComHuonekorttiValinta from "./ComHuonekorttiValinta.vue"
import { useHakuSelection } from "@/methods/hakuSelectionComposables";
import { setNodes, useNimikeKategoria } from "@/methods/nimikkeetComposables";
import { ref, toRef, watch, watchEffect } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComNimikeRaportti',
  props: {
    "huonekorteittain": { type: Boolean, ...{ default: false } },
    "huonekorteittainModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["nimikkeet"], ["update:huonekorteittain"]),
  setup(__props, { emit: __emit }) {

const emit = __emit
const huonekorteittain = _useModel<boolean>(__props, "huonekorteittain")
const { nimikeKategoriat } = useNimikeKategoria(toRef(true))
const valitutNimikkeet = ref<[number, number, number][]>([])
const { model: hakuModel} = useHakuSelection(valitutNimikkeet)
const nimikkeet = ref()

watch(valitutNimikkeet, () => {
    let n: number[] = []

    if (valitutNimikkeet.value) {
        n = valitutNimikkeet.value?.map((v: number[]) => {
            return v[2]
        })
    }

    emit("nimikkeet", n)
})

watchEffect(() => {
    nimikkeet.value = setNodes(nimikeKategoriat.value ?? [], true)
})


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_cascader_panel = _resolveComponent("el-cascader-panel")!

  return (!nimikkeet.value)
    ? (_openBlock(), _createBlock(ComLoading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(ComCascaderSearch, {
                      modelValue: _unref(hakuModel),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(hakuModel) ? (hakuModel).value = $event : null))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader_panel, {
                  options: nimikkeet.value,
                  props: {
                    disabled: false,
                    multiple: true,
                },
                  modelValue: valitutNimikkeet.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((valitutNimikkeet).value = $event))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ComHuonekorttiValinta, {
          modelValue: huonekorteittain.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((huonekorteittain).value = $event))
        }, null, 8, ["modelValue"])
      ]))
}
}

})